export default function (value, decimalplaces = 2) {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string' && (value.includes(','))) {
    return value
  }
  return Number(value).toFixed(decimalplaces).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
